<template>
  <div>
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountBondObjDetail.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="accountBondObjDetailInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-select v-model="accountBondObjDetailInfo.conditions.objId" style="width:200px"
              :placeholder="$t('accountBondObjDetail.selectShop')">
              <el-option v-for="item in accountBondObjDetailInfo.shops" :key="item.shopId" :label="item.shopName"
                :value="item.shopId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="accountBondObjDetailInfo.conditions.state" style="width:200px"
              :placeholder="$t('accountBondObjDetail.selectStatus')">
              <el-option :value="3308" :label="$t('accountBondObjDetail.payBond')"></el-option>
              <el-option :value="3309" :label="$t('accountBondObjDetail.refundBond')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="_queryAccountBondObjDetailMethod()">
              <i class="el-icon-search"></i>
              {{ $t('accountBondObjDetail.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('accountBondObjDetail.bondDetails') }}</div>
      </div>
      <div class="">
        <el-table :data="accountBondObjDetailInfo.details" stripe border style="width: 100%"
          :header-cell-style="{ background: '#f8f9fa', color: '#606266', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="bobjId" :label="$t('accountBondObjDetail.bondId')" width="120">
          </el-table-column>
          <el-table-column prop="objName" :label="$t('accountBondObjDetail.bondObj')" >
          </el-table-column>
          <el-table-column prop="receivableAmount" :label="$t('accountBondObjDetail.receivableAmount')" >
          </el-table-column>
          <el-table-column prop="receivedAmount" :label="$t('accountBondObjDetail.receivedAmount')" >
          </el-table-column>
          <el-table-column prop="state" :label="$t('accountBondObjDetail.status')" >
            <template slot-scope="scope">
              {{ scope.row.state == 3308 ? $t('accountBondObjDetail.payBond') : $t('accountBondObjDetail.refundBond') }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" :label="$t('accountBondObjDetail.startTime')" >
          </el-table-column>
          <el-table-column prop="endTime" :label="$t('accountBondObjDetail.endTime')" >
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next" class="text-center">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAccountBondObjDetail, queryBondShops } from '@/api/admin/accountBondObjDetail/accountBondObjDetailApi'

export default {
  name: 'AccountBondObjDetail',
  components: {
  },
  data() {
    return {
      accountBondObjDetailInfo: {
        details: [],
        shops: [],
        conditions: {
          state: '',
          objId: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopId: ''
    }
  },
  created() {
    this._listAccountBondObjsDetail(1, 10)
    this._listBondShops(1, 50)
  },
  methods: {
    async _listAccountBondObjsDetail(page, rows) {
      this.accountBondObjDetailInfo.conditions.page = page
      this.accountBondObjDetailInfo.conditions.row = rows

      try {
        const res = await queryAccountBondObjDetail(this.accountBondObjDetailInfo.conditions)
        this.accountBondObjDetailInfo.details = res.data
        this.total = res.total
        this.currentPage = page
      } catch (error) {
        console.error('查询保证金明细失败:', error)
      }
    },
    async _listBondShops(page, rows) {
      try {
        const res = await queryBondShops({
          page,
          row: rows,
          shopId: this.shopId
        })
        this.accountBondObjDetailInfo.shops = res.data
      } catch (error) {
        console.error('查询商铺列表失败:', error)
      }
    },
    _queryAccountBondObjDetailMethod() {
      this._listAccountBondObjsDetail(1, 10)
    },
    handlePageChange(currentPage) {
      this._listAccountBondObjsDetail(currentPage, 10)
    }
  }
}
</script>

<style scoped>
.margin-top-sm {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.justify-start {
  justify-content: flex-start;
}

.text-center {
  text-align: center !important;
}

/* 分页居中 */
.el-pagination {
  text-align: center;
  margin-top: 20px;
}

/* 表单行间距 */
.el-form-item {
  margin-bottom: 18px;
  margin-right: 18px;
}

/* 卡片内容区域 */
.el-card__body {
  padding: 20px;
}

/* 表格样式优化 */
.el-table {
  margin-bottom: 20px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-form--inline .el-form-item {
    display: block;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .el-select {
    width: 100% !important;
  }
}
</style>